import { Route, BrowserRouter, Routes } from 'react-router-dom';
import './App.css';
import Editor from './pages/editor';
import Card from './pages/card';
import Myballs from './pages/myballs';
import Weeknotes from './pages/weeknotes';
import Login from './pages/login';
import Reg from './pages/reg';
import { useEffect, useState } from 'react';
import { ajax } from 'jquery';
import Settings from './pages/settings';
import Setting from './pages/setting';
import Featured from "./pages/featured";
import AdminNotes from './pages/adminNotes';
import Note from './pages/note';

function App() {

  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    const checkLogin = async () => {
      try {
        const user = await ajax({
          method: "GET",
          url: `/api/v1/countryball_card/user`,
        })
        if (user.isAdmin === 1) {
          setIsAdmin(true);
        }
      } catch (err) {
        // 只有需要登录的页面才重定向到登录页面
        const currentPath = window.location.pathname;
        const publicPaths = ['/featured', '/card/', '/note/', '/login', '/reg'];
        const isPublicPath = publicPaths.some(path => 
          currentPath.startsWith(path) || currentPath === path
        );
        
        if (!isPublicPath) {
          window.location.href = '/login'
        }
      }
    }
    
    // 检查当前路径是否需要登录
    const currentPath = window.location.pathname;
    const publicPaths = ['/featured', '/card/', '/note/', '/login', '/reg'];
    const isPublicPath = publicPaths.some(path => 
      currentPath.startsWith(path) || currentPath === path
    );
    
    if (!isPublicPath) {
      checkLogin()
    } else {
      // 对于公开页面，仍然尝试获取用户信息来判断是否为管理员，但不强制登录
      checkLogin()
    }
  }, [])

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/note/edit' element={<Editor />} />
          <Route path='/note/edit/:date' element={<Editor />} />
          <Route path='/weeknotes' element={<Weeknotes />} />
          <Route path='/myballs' element={<Myballs />} />
          <Route path='/note/:noteId' element={<Note />} />
          <Route path='/card/:hash' element={<Card />} />
          <Route path='/reg' element={<Reg />} />
          <Route path='/login' element={<Login />} />
          <Route path='/settings' element={<Setting />} />
          <Route path='/featured' element={<Featured />} />
          <Route path='/admin/notes' element={<AdminNotes />} />
        </Routes>
      </BrowserRouter>
      <div className="bottom-nav">
        <a href="/weeknotes" className="nav-wrap weeknotes">
          <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4510" width="200" height="200"><path d="M725.333333 170.666667h74.709334C864.853333 170.666667 917.333333 223.189333 917.333333 288.096V799.893333C917.333333 864.757333 864.832 917.333333 800.042667 917.333333H223.957333C159.146667 917.333333 106.666667 864.810667 106.666667 799.904V288.106667C106.666667 223.242667 159.168 170.666667 223.957333 170.666667H298.666667v-32a32 32 0 0 1 64 0v32h298.666666v-32a32 32 0 0 1 64 0v32z m0 64v32a32 32 0 0 1-64 0v-32H362.666667v32a32 32 0 0 1-64 0v-32h-74.709334A53.354667 53.354667 0 0 0 170.666667 288.096V799.893333A53.301333 53.301333 0 0 0 223.957333 853.333333h576.085334A53.354667 53.354667 0 0 0 853.333333 799.904V288.106667A53.301333 53.301333 0 0 0 800.042667 234.666667H725.333333z m-10.666666 224a32 32 0 0 1 0 64H309.333333a32 32 0 0 1 0-64h405.333334zM586.666667 618.666667a32 32 0 0 1 0 64H309.333333a32 32 0 0 1 0-64h277.333334z" fill="#2c2c2c" p-id="4511"></path></svg>
          <span className="text">国家球日历</span>
        </a>
        <a href="/featured" className="nav-wrap weeknotes">
          <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2664" width="200" height="200"><path d="M753.92 128h1.664c-0.490667 0-0.853333 0.021333-1.216-0.128 0.384 0.149333 0.725333 0.128 1.216 0.128h-1.685333l-0.853334-1.322667 0.853334 1.322667H250.581333l-142.08 237.653333 374.122667 486.528-29.546667-38.4L319.722667 384h-197.12l-14.08-18.346667 14.549333-24.32h183.402667l-62.677334-201.984 6.784-11.349333h34.368l59.754667 192.576L471.893333 128h79.765334l123.370666 186.794667L732.992 128h20.906667l16.192 24.405333L711.466667 341.333333h183.850666l19.562667 29.525334-10.197333 13.141333H698.24l-137.941333 444.522667-48.106667 62.08-29.546667-38.4 29.546667 38.4 402.709333-519.744L753.898667 128zM215.509333 103.488c5.973333-10.026667 20.394667-18.154667 32.085334-18.154667h507.946666c11.733333 0 26.538667 7.978667 33.024 17.770667l166.997334 251.925333c6.485333 9.813333 6.016 25.173333-1.365334 34.709334L538.154667 926.741333c-14.421333 18.602667-37.824 18.474667-52.202667-0.234666L70.144 385.749333c-7.253333-9.429333-8.256-25.237333-2.282667-35.221333l147.669334-247.04z m145.536 269.76l147.904 476.650667 149.696-482.432L511.786667 145.045333l-150.72 228.202667z" fill="#2c2c2c" p-id="2665"></path></svg>
          <span className="text">精选日记</span>
        </a>
        {
          isAdmin && (
            <a href="/admin/notes" className="nav-wrap myballs">
              <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2664" width="200" height="200"><path d="M753.92 128h1.664c-0.490667 0-0.853333 0.021333-1.216-0.128 0.384 0.149333 0.725333 0.128 1.216 0.128h-1.685333l-0.853334-1.322667 0.853334 1.322667H250.581333l-142.08 237.653333 374.122667 486.528-29.546667-38.4L319.722667 384h-197.12l-14.08-18.346667 14.549333-24.32h183.402667l-62.677334-201.984 6.784-11.349333h34.368l59.754667 192.576L471.893333 128h79.765334l123.370666 186.794667L732.992 128h20.906667l16.192 24.405333L711.466667 341.333333h183.850666l19.562667 29.525334-10.197333 13.141333H698.24l-137.941333 444.522667-48.106667 62.08-29.546667-38.4 29.546667 38.4 402.709333-519.744L753.898667 128zM215.509333 103.488c5.973333-10.026667 20.394667-18.154667 32.085334-18.154667h507.946666c11.733333 0 26.538667 7.978667 33.024 17.770667l166.997334 251.925333c6.485333 9.813333 6.016 25.173333-1.365334 34.709334L538.154667 926.741333c-14.421333 18.602667-37.824 18.474667-52.202667-0.234666L70.144 385.749333c-7.253333-9.429333-8.256-25.237333-2.282667-35.221333l147.669334-247.04z m145.536 269.76l147.904 476.650667 149.696-482.432L511.786667 145.045333l-150.72 228.202667z" fill="#2c2c2c" p-id="2665"></path></svg>
              <span className="text">管理日记</span>
            </a>
          )
        }
        <a href="/myballs" className="nav-wrap myballs">
          <img src="/popular-pic.png" alt="" className='icon' />
          <span className="text">我的国家球</span>
        </a>
        <a href="/settings" className="nav-wrap settings">
          <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9244" width="200" height="200"><path d="M396.72 320.592a141.184 141.184 0 0 1-99.824 15.92 277.648 277.648 0 0 0-45.344 74.576 141.216 141.216 0 0 1 37.52 95.952 141.248 141.248 0 0 1-41.728 100.32 274.4 274.4 0 0 0 49.952 86.224 141.264 141.264 0 0 1 107.168 14.176 141.216 141.216 0 0 1 63.984 79.296 274.72 274.72 0 0 0 86.816-1.92 141.248 141.248 0 0 1 66.016-86.304 141.216 141.216 0 0 1 101.856-15.488 277.648 277.648 0 0 0 41.92-76.544 141.184 141.184 0 0 1-36.128-94.4c0-34.912 12.768-67.68 34.816-92.96a274.736 274.736 0 0 0-38.192-70.032 141.264 141.264 0 0 1-105.792-14.56 141.312 141.312 0 0 1-67.168-90.912 274.4 274.4 0 0 0-92.784 0.016 141.152 141.152 0 0 1-63.088 76.64z m22.56-116.656c57.312-16 119.024-16.224 178.016 1.216a93.44 93.44 0 0 0 142.288 86.736 322.64 322.64 0 0 1 79.104 142.656 93.328 93.328 0 0 0-41.76 77.84 93.36 93.36 0 0 0 42.88 78.592 322.832 322.832 0 0 1-34.208 85.232 323.392 323.392 0 0 1-47.968 63.568 93.392 93.392 0 0 0-92.352 0.64 93.408 93.408 0 0 0-46.688 83.616 322.704 322.704 0 0 1-171.424 3.84 93.376 93.376 0 0 0-46.704-78.544 93.408 93.408 0 0 0-95.184 1.008A322.432 322.432 0 0 1 192 589.28a93.408 93.408 0 0 0 49.072-82.24c0-34.128-18.304-64-45.632-80.288a323.392 323.392 0 0 1 31.088-73.328 322.832 322.832 0 0 1 56.704-72.256 93.36 93.36 0 0 0 89.488-2.144 93.328 93.328 0 0 0 46.56-75.088z m92.208 385.28a68.864 68.864 0 1 0 0-137.76 68.864 68.864 0 0 0 0 137.76z m0 48a116.864 116.864 0 1 1 0-233.76 116.864 116.864 0 0 1 0 233.76z" p-id="9245"></path></svg>
          <span className="text">设置</span>
        </a>
      </div>
    </div>
  );
}

export default App;
